module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/cashmovements/cash-movement.component.html
// module id = 1206
// module chunks = 0